import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import type { PurchaseIntent, TradeInVehicle, VehicleInterest } from '../types/lead';
interface LeadContextValue {
  /** Category chosen by the visitor, pre-selects the form field. */
  vehicleInterest: VehicleInterest;
  setVehicleInterest: (value: VehicleInterest) => void;
  /** Preset intent, e.g. the trade-in section routes in with 'trade-in-buy'. */
  presetIntent: PurchaseIntent;
  setPresetIntent: (value: PurchaseIntent) => void;
  /** VIN / mileage / payoff captured by the trade-in section, carried into the lead payload. */
  tradeIn: TradeInVehicle | null;
  setTradeIn: (value: TradeInVehicle | null) => void;
  /** First name captured by the form, used to personalize the WhatsApp message. */
  leadName: string;
  setLeadName: (value: string) => void;
  hasSubmitted: boolean;
  setHasSubmitted: (value: boolean) => void;
}
const LeadContext = createContext<LeadContextValue | null>(null);
export function LeadProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [vehicleInterest, setVehicleInterest] = useState<VehicleInterest>('');
  const [presetIntent, setPresetIntent] = useState<PurchaseIntent>('');
  const [tradeIn, setTradeIn] = useState<TradeInVehicle | null>(null);
  const [leadName, setLeadName] = useState('');
  const [hasSubmitted, setHasSubmitted] = useState(false);
  const value = useMemo(() => ({
    vehicleInterest,
    setVehicleInterest,
    presetIntent,
    setPresetIntent,
    tradeIn,
    setTradeIn,
    leadName,
    setLeadName,
    hasSubmitted,
    setHasSubmitted
  }), [vehicleInterest, presetIntent, tradeIn, leadName, hasSubmitted]);
  return <LeadContext.Provider value={value} data-id="element-480" data-mp="3owkns1w6dxcs">{children}</LeadContext.Provider>;
}
export function useLead(): LeadContextValue {
  const ctx = useContext(LeadContext);
  if (!ctx) throw new Error('useLead must be used within LeadProvider');
  return ctx;
}